import { requestService as api } from "../Request.service"  

const API_URL = {
  API_MANAGE: `/ERP/pg/manage.php`,
  API_SEARCH: `/ERP/pg/search.php`,
  Upload_Pic: `/ERP/pg/upload_pic.php`,
  Delete_Pic: `/ERP/pg/delete_pic.php`,
  Delete_Pic_Update: `/ERP/pg/delete_pic_update.php`,
  API_PRINT_PL: `/ERP/pg/pl-pg-print.php`,
};



const ProductService = () => { 
 
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);
  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, {...config, cancle: true});
  const uploadPic = (parm = {}) =>  api.post(`${API_URL.Upload_Pic}`, parm);
  const deletePic = (parm = {}) =>  api.post(`${API_URL.Delete_Pic}`, parm);
  const deletePicUpdate = (parm = {}) =>  api.post(`${API_URL.Delete_Pic_Update}`, parm);

  const printpl = (code_detail) => api.get(`${API_URL.API_PRINT_PL}?code=${code_detail}`);
  
  return {
    create,
    update,
    deleted,
    get,
    search,
    uploadPic,
    deletePic,
    deletePicUpdate,
    printpl
  };
};

export default ProductService;
